const ACTIVATION_GUIDE_CONSTANTS = {
    title: {
        esimTitle: "Let's get started with your new eSIM",
        activationTitle: "We're activating your service",
        portingTitle: "We're transferring your service"
    },
    porting: {
        esimPorting: "Download your eSIM profile now. You'll receive an email when your service is ready to use.",
        portingSimHeader: 'Keep the current SIM in your device',
        portingSimContent: 'Use the old SIM from your previous provider for now. Once your service is disconnected, you can insert your new Boost SIM.',
    },
    getNewNumber: {
        esimTitleMessage: "Download your eSIM profile now. You'll receive an email when your service is ready to use.",
        numSimHeader: 'Insert your SIM',
        numSimContent: "If you haven't already, insert your new Boost SIM now."
    },
    common: {
        subTitle: "Welcome to Australia's largest mobile network.",
        setupAccountHeader: 'Set up your account',
        setupAccountContent: "You may already have a Boost ID, even if you haven't used your service recently. If you're unsure, enter your email on sign in and follow the 'recover account' prompts. This is an optional step.",
        manageServiceHeader: 'Manage your service with My Boost',
        manageServiceContent: 'to manage your service with My Boost.',
        detailMessage: ". We've sent you an email to create a password or passkey to finish setting up your account and help keep your account safe. You'll also need it to sign in to recharge online or in My Boost. This is an optional step."
    },
    directoryListing: {
        header: 'Directory listing',
        contactUsMessage: 'How to change your listing',
        // eslint-disable-next-line max-len
        content: 'Your name, address and phone number will not be listed in the directory assistance or the printed and online public directories. You can change this setting in My Boost.'
    },
    esimProfileError: {
        esimProfileErrortitle: 'Nearly there!',
        esimProfileErrorTitleMessage:
            'Please wait for our email confirming that your eSIM is active and then follow the steps below to download your eSIM profile in the My Boost Mobile app.',
        step1: 'Step 1',
        step1Message: 'After receiving the Telstra welcome email, open the My Boost Mobile app.',
        step2: 'Step 2',
        step2Message: 'On the services tab, select your new eSIM service?',
        step3: 'Step 3',
        step3Message: 'On the service summary page, select Transfer or restore eSIM.',
        step4: 'Step 4',
        step4Message: 'Select Transfer service to this device and ensure you are connected to Wi-Fi.',
        step5: 'Step 5',
        step5Message: 'Follow the steps to verify your account.',
        step6: 'Step 6',
        step6Message: 'Install and download your eSIM profile.'
    }
};

export default ACTIVATION_GUIDE_CONSTANTS;
